<ng-container *ngIf="selectedDistrict">
  <span *ngIf="includeDash"> - </span> {{ selectedDistrict.title }}
</ng-container>
